<template>
  <div>
    <van-nav-bar
      title="好友现金券"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/member/members')"
    />
    <van-cell style="">
      <template #title>
        <span class="custom-title">余额: {{ amountPlus }}元</span>
      </template>
      <!-- 使用 right-icon 插槽来自定义右侧图标 -->
      <template #right-icon>
        <van-button type="danger" round size="mini" @click="goPage"
          >使用须知</van-button
        >
      </template>
    </van-cell>

    <van-empty image="error" description="暂无好友现金券" v-if="isCoupon" />
    <div class="table-title" v-if="!isCoupon">
      <div>赠送日期</div>
      <div>到期日期</div>
      <div>金额</div>
      <div>状态</div>
      <div>推广二维码/链接</div>
    </div>
    <van-loading v-if="isLoading" style="text-align:center;padding-top:20px;">加载中...</van-loading>
    <div class="table-content" v-for="(item, index) in all_coupon" :key="index">
      <div>{{ item.approvetime }}</div>
      <div>{{ item.effect_date }}</div>
      <div>{{ item.amount }}</div>
      <div>{{ item.statustext }}</div>
      <div>
        <span v-if="item.status == 1"
          ><van-button
            type="danger"
            round
            size="mini"
            @click="goDetails"
            style="border-radius: 25px; width: 80px; color: #ffffff"
            >详情</van-button
          ></span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FriendCoupon",
  data() {
    return {
      all_coupon: [],
      amountPlus: 0,
      isCoupon: false,
      isLoading:false,
    };
  },
  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    friendCoupon() {
      let that = this;
      that.isLoading=true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "friend_coupon",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          that.isLoading=false;
          let resData = res.data;
          if (res.data.code === 1) {
            that.all_coupon = resData.data;
            if (that.all_coupon.length < 1) {
              that.isCoupon = true;
            }
            for (let i = 0; i < that.all_coupon.length; i++) {
              if (that.all_coupon[i].status === 1) {
                that.amountPlus = that.amountPlus + that.all_coupon[i].amount;
              }
            }
          } else {
            that.$toast.fail(resData.msg);
          }
        })
        .catch(() => {
          that.isLoading=false;
        });
    },
    goPage() {
      this.$router.push({
        path: "/protocol",
        query: { type: 21 },
      });
    },
    goDetails() {
      this.$router.push({
        path: "/member/agency/agency_link",
      });
    },
  },
  mounted: function () {
    let that = this;
    this.isLogin();
    this.friendCoupon();
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.custom-title {
  color: red;
}
.table-content,
.table-title {
  width: 100%;
  overflow: hidden;
}
.table-title > div {
  width: 18%;
  float: left;
  padding: 10px 0;
  text-align: center;
  font-size: 12px;
  background: #c8c9cc;
}
.table-content > div {
  width: 18%;
  float: left;
  padding: 10px 0;
  text-align: center;
  font-size: 12px;
}
.table-content > div:last-child {
  width: 28% !important;
}
.table-title > div:last-child {
  width: 28% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/FriendCoupon.vue